import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
    name: ''
  }
})

export default {
  [types.SET_HOTEL_ALLOCATION] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.allocation = payload
  },
  [types.SET_HOTEL_ALLOCATIONS] (state, payload) {
    state.allocations = payload.data
    state.pagination = payload.meta.pagination
  }
}
